import { render } from "./Bridge2.vue?vue&type=template&id=92e0c2a4"
import script from "./Bridge2.vue?vue&type=script&lang=ts"
export * from "./Bridge2.vue?vue&type=script&lang=ts"
script.render = render

export default script